module.exports = __webpack_public_path__ + "img/Luxembourg.b3da342e.svg";